/* =====================================================================
 * Varniya - WhatsApp link page-URL appender
 * ---------------------------------------------------------------------
 * Rewrites every WhatsApp link on the page so the pre-filled message
 * carries the current page URL (encoded). Also normalizes the phone
 * number to the primary business number and repairs known-broken
 * numbers (stray space / missing country code / literal code artifact).
 *
 * Idempotent & non-destructive: links whose message already references
 * a URL (buttons that inject it via their own inline script, or
 * server-side {{ full_url }}) keep their text - only the number is
 * normalized - so nothing is ever double-appended.
 *
 * Excludes the social "share" button (whatsapp://) by design.
 * ===================================================================== */
(function () {
  var WA_NUMBER = '917799442578';

  function vnyEnhanceWhatsAppLinks() {
    var pageUrl = window.location.href;
    var links = document.querySelectorAll(
      'a[href*="wa.me"], a[href*="api.whatsapp.com"], a[href*="whatsapp.com/send"]'
    );

    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.getAttribute('data-wa-enhanced') === '1') continue;

      var href = (a.getAttribute('href') || '').replace(/&amp;/g, '&');
      if (!/wa\.me|whatsapp\.com/i.test(href)) continue;

      var isWaMe = /wa\.me/i.test(href);

      // Read the existing text= parameter, if any.
      var query = '';
      var qIndex = href.indexOf('?');
      if (qIndex !== -1) query = href.slice(qIndex + 1);

      var textRaw = '';
      var parts = query.split('&');
      for (var p = 0; p < parts.length; p++) {
        if (parts[p].indexOf('text=') === 0) { textRaw = parts[p].slice(5); break; }
      }

      var textVal = '';
      try { textVal = decodeURIComponent(textRaw.replace(/\+/g, '%20')); }
      catch (e) { textVal = textRaw; }

      // Remove the literal artifact left by a previous failed attempt.
      textVal = textVal.replace(/\+?\s*encodeURIComponent\s*\(\s*currentUrl\s*\)/gi, '').trim();

      var alreadyHasUrl = /https?:\/\//i.test(textVal);

      var newText;
      if (alreadyHasUrl) {
        newText = textVal;                          // keep as-is (URL already present)
      } else if (textVal) {
        newText = textVal + ' | Page: ' + pageUrl;  // keep context, add the page
      } else {
        newText = 'I have a question about ' + pageUrl;
      }

      var newHref = isWaMe
        ? 'https://wa.me/' + WA_NUMBER + '?text=' + encodeURIComponent(newText)
        : 'https://api.whatsapp.com/send?phone=' + WA_NUMBER + '&text=' + encodeURIComponent(newText);

      a.setAttribute('href', newHref);
      a.setAttribute('data-wa-enhanced', '1');
    }
  }

  function vnyInit() {
    vnyEnhanceWhatsAppLinks();
    // Re-run once shortly after load to catch links whose href is set by
    // other scripts or injected late. Enhanced links are skipped.
    setTimeout(vnyEnhanceWhatsAppLinks, 1000);
  }

  if (document.readyState === 'complete') {
    vnyInit();
  } else {
    window.addEventListener('load', vnyInit);
  }
})();
